import * as React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useEffect, useState } from "react";
import HeatMap from "react-heatmap-grid";
import useFetch from "../useFetch";
import BaseDropdown from "./BaseDropdown";

const BenchmarkComponent = (props) => {
  const [groupBy, setGroupBy] = useState("Global");
  const [units, setUnits] = useState("percentage");
  const [yLabels, setYLabels] = useState([]);
  const [xLabels, setXLabels] = useState([]);
  const [heatmapData, setHeatmapData] = useState(null);
  const [{ data, isPending, error }, doFetch] = useFetch();

  const benchmarkNames = {
    tenure: "Betriebszugehörigkeit",
    collar: "White/ Blue Collar Tätigkeit",
    gender: "Geschlecht",
    Groe: "Unternehmensgröße",
    Global: "Global",
  };
  const unitNames = {
    mean: "Mittlere Zustimmung",
    percentage: "Prozentuale Zustimmung",
  };

  const unitFormatters = {
    mean: (x) => Math.round(x * 100) / 100,
    percentage: (x) => `${Math.round(x * 100)}`,
  };

  // const host = "http://127.0.0.1:6848";
  const host = "https://www.functionhr.de:6848/ext/api";
  const url = `${host}/average/${groupBy}?units=${units}`;

  useEffect(() => {
    if (!data) return;

    let formatter = unitFormatters[units];

    let columnLabels = Object.keys(data[0]).slice(1);
    let rowLabels = data.map((el) => el[benchmarkNames[groupBy || "Global"]]);

    let data2DArray = data.map((row) => {
      return columnLabels.map((column) => formatter(row[column]));
    });

    setHeatmapData(data2DArray);
    setXLabels(columnLabels);
    setYLabels(rowLabels);
  }, [data]);

  useEffect(() => {
    doFetch(url);
  }, [groupBy, units]);

  return (
    <div className="benchmark-component">
      <div className="dropdowns">
        <BaseDropdown
          title="Wähle die Gruppe"
          options={benchmarkNames}
          selectedOption={groupBy}
          setSelectedOption={setGroupBy}
        />
        {groupBy && (
          <BaseDropdown
            title="Choose units"
            options={unitNames}
            selectedOption={units}
            setSelectedOption={setUnits}
          />
        )}
      </div>
      {error && <div></div>}
      {isPending && <div>Loading...</div>}
      {heatmapData && (
        <div>
          <div className="heatmap">
            <HeatMap
              xLabels={xLabels}
              yLabels={yLabels}
              data={heatmapData}
              yLabelWidth={240}
              height={50}
              yLabelTextAlign="left"
              cellStyle={(background, value, min, max, data, x, y) => {
                let fontColor;
                if (units === "mean") {
                  // Customize colors based on the "mean" unit
                  fontColor = value > 5.2 ? "white" : "black";
                } else if (!units || units === "percentage") {
                  fontColor = value > 70 ? "white" : "black";
                } else {
                  fontColor = "black";
                }

                const minAlpha = 0.2;
                return {
                  background: `rgba(27, 32, 148, ${Math.max(
                    1 - (max - value) / (max - min),
                    minAlpha
                  )})`,
                  color: fontColor,
                  borderRadius: "0.375rem",
                };
              }}
              cellRender={(value) =>
                units === "percentage" && value !== undefined
                  ? `${value}%`
                  : value
              }
              title={(value, unit) => `${value}`}
            />{" "}
          </div>
        </div>
      )}
    </div>
  );
};

export default BenchmarkComponent;
